<script lang="ts" setup>
import { IBeleg } from "../api/useAuftrag";
import ZeitBox from "./ZeitBox.vue";
import BelegBearbeiten from "../actions/BelegBearbeiten.vue";
import BelegLoeschen from "../actions/BelegLoeschen.vue";
import { formatEuro } from "@/utils/currency";

defineProps<{
  beleg: IBeleg;
  query: () => void;
  auftragId: string;
}>();
</script>

<template>
  <ZeitBox :datum="beleg.datum">
    <div class="flex justify-between">
      <div>
        {{ beleg.beschreibung }}
      </div>
      <div></div>
    </div>
    <div class="flex justify-between">
      <div>{{ formatEuro(beleg.betrag) }}</div>
      <div class="flex space-x-2">
        <BelegBearbeiten
          :query="query"
          :beleg-id="beleg.id"
          :beschreibung="beleg.beschreibung"
          :betrag="beleg.betrag"
          :datum="beleg.datum"
        />
        <BelegLoeschen
          :query="query"
          :beleg-id="beleg.id"
          :beschreibung="beleg.beschreibung"
          :betrag="beleg.betrag"
        />
      </div>
    </div>
  </ZeitBox>
</template>
